/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/core-client/js/core-client/utils/ClassFactory',
	'../../../app/nls/StringResources',
	'./MigrateUtils'
], ( ClassFactory, StringResources,MigrateUtils) => {

	/**
	 * @description
	 */
	class MigrateCDE {
		constructor(spec, options) {
			this.dashboardApi = options.dashboardApi;
			this.logger = options.logger;
			this.ajaxSvc = options.ajaxSvc;
			this.spec = spec;
		}

		migrate(dashboardId, options = {}) {
			return this._migrateCDE(dashboardId, options);
		}

		_getShapingUIUtilsClass() {
			return ClassFactory.loadModule('dashboard-analytics/dataSources/utils/ShapingUIUtils');
		}

		_migrateCDE(dashboardId, options) {
			return new Promise((resolve, reject) => {
				try {
					const { dataSources } = this.spec;
					const dataSourcesJson = dataSources.toJSON ? dataSources.toJSON() : JSON.parse(JSON.stringify(dataSources));
					const sources = dataSourcesJson.sources;
					let completeMessage = options.completeMessage;
					return this._getShapingUIUtilsClass().then(ShapingUIUtils => {
						return ShapingUIUtils.migrateCDE(
							sources,
							dashboardId,
							{
								ajaxService: this.ajaxSvc,
								logger: this.logger
							}
						).then(newSources => {
							dataSourcesJson.sources = [];
							if (newSources && newSources.sources && Array.isArray(newSources.sources)) {
								newSources.sources.forEach(source => {
									dataSourcesJson.sources.push(source);
								});
							}
							if (!MigrateUtils.isEmpty(newSources.cdeGroupedSourcesFailedToConvert)) {
								dataSourcesJson.cdeGroupedSourcesFailedToConvert = newSources.cdeGroupedSourcesFailedToConvert;
							}
							if (newSources.numSourcesMigrateFailed && newSources.numSourcesMigrateFailed > 0) {
								completeMessage = StringResources.get('migratingDataSourcesFailed');
							}
							this.spec.dataSources = dataSourcesJson;
							return resolve({ spec: this.spec, completeMessage: completeMessage });
						});
					}).catch(err => {
						return reject(err);
					});
				} catch (error) {
					reject(error);
				}
			});
		}

		needDataMigration() {
			if (MigrateUtils.specMissing(this.spec)) {
				return false;
			}
			const { dataSources } = this.spec;
			return dataSources && !MigrateUtils.isEmpty(dataSources.sources) && MigrateUtils.isInlineModule(dataSources.sources);
		}

		flagSourcesAsDoNotUse() {
			const { dataSources } = this.spec;
			dataSources.sources = [];
			return this.spec;
		}
	}
	return MigrateCDE;
});